import "../../../FhSelect.css";
import { toRef, watch, ref, computed, provide, reactive, openBlock, createElementBlock, normalizeClass, renderSlot, createVNode, unref, createSlots, withCtx, mergeProps, toDisplayString, createCommentVNode, Fragment, renderList, createBlock, createTextVNode } from "vue";
import useIsFieldRequired from "../composables/useIsFieldRequired.mjs";
import useFormField from "../composables/useFormField.mjs";
import { InputFieldContextKey } from "../Symbols.mjs";
import { generateUniqueId } from "../../utils.mjs";
import FhValidationMessage from "../FhValidationMessage/FhValidationMessage.mjs";
import FhInputContainer from "../FhInputContainer/FhInputContainer.mjs";
import FhSelectField from "./FhSelectField.mjs";
import chevronDown from "../../../icons/chevronDown.mjs";
import { SIZES_ENUMS } from "../FhInputContainer/constants.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = {
  key: 0,
  value: "",
  selected: "true",
  disabled: ""
};
const _hoisted_2 = ["value", "disabled"];
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhSelect",
  props: {
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    validators: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: SIZES_ENUMS.SM,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const {
      value: inputValue,
      withinForm,
      meta,
      setValue,
      errorMessage,
      handleBlur: handleSelectBlur
    } = useFormField(props.name, props.modelValue, {
      validators: toRef(props, "validators"),
      disabled: toRef(props, "disabled")
    });
    if (!withinForm) {
      watch(
        () => props.modelValue,
        (newValue) => {
          if (newValue !== inputValue.value) {
            setValue(newValue);
          }
        }
      );
    }
    const uniqueId = generateUniqueId();
    const required = useIsFieldRequired();
    const componentId = `fh-input--${uniqueId}`;
    const validationId = `fh-validation--${uniqueId}`;
    const inputFocused = ref(false);
    const computedInvalid = computed(() => {
      return (errorMessage == null ? void 0 : errorMessage.value) && meta.touched;
    });
    const computedClasses = computed(() => {
      return "fh-select-wrap";
    });
    const handleFocus = () => {
      inputFocused.value = true;
    };
    const handleChange = (event) => {
      const { value: newValue } = event.target;
      setValue(newValue);
      if (!withinForm) {
        emit("update:modelValue", newValue);
      }
    };
    const handleBlur = (event) => {
      handleSelectBlur(event);
      inputFocused.value = false;
    };
    provide(
      InputFieldContextKey,
      reactive({
        disabled: toRef(props, "disabled"),
        id: componentId,
        focused: inputFocused,
        valid: toRef(() => !computedInvalid.value)
      })
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(computedClasses.value)
      }, [
        _ctx.$slots.label ? renderSlot(_ctx.$slots, "label", { key: 0 }, void 0, true) : renderSlot(_ctx.$slots, "default", { key: 1 }, void 0, true),
        createVNode(FhInputContainer, {
          "max-width": props.maxWidth,
          prefixIcon: props.prefixIcon,
          decoratorIcon: unref(chevronDown),
          size: props.size,
          disabled: props.disabled
        }, createSlots({
          default: withCtx(() => [
            createVNode(FhSelectField, mergeProps({
              name: props.name,
              id: componentId,
              "aria-required": unref(required),
              "aria-errormessage": computedInvalid.value && validationId,
              disabled: props.disabled,
              value: unref(inputValue)
            }, _ctx.$attrs, {
              onFocus: handleFocus,
              onChange: handleChange,
              onBlur: handleBlur
            }), {
              default: withCtx(() => [
                props.placeholder ? (openBlock(), createElementBlock("option", _hoisted_1, toDisplayString(props.placeholder), 1)) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (item, key) => {
                  return openBlock(), createElementBlock("option", {
                    key,
                    value: item.value,
                    disabled: item.disabled
                  }, toDisplayString(item.label), 9, _hoisted_2);
                }), 128))
              ]),
              _: 1
            }, 16, ["name", "aria-required", "aria-errormessage", "disabled", "value"])
          ]),
          _: 2
        }, [
          _ctx.$slots.prefix ? {
            name: "prefix",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
            ]),
            key: "0"
          } : void 0,
          _ctx.$slots.action ? {
            name: "action",
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, "action", {}, void 0, true)
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["max-width", "prefixIcon", "decoratorIcon", "size", "disabled"]),
        computedInvalid.value ? (openBlock(), createBlock(FhValidationMessage, {
          key: 2,
          id: validationId
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(errorMessage)), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const FhSelect = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e291f3c9"]]);
export {
  FhSelect as default
};
//# sourceMappingURL=FhSelect.mjs.map
